import { render, staticRenderFns } from "./stapes.vue?vue&type=template&id=4ec7f3b4&scoped=true"
import script from "./stapes.vue?vue&type=script&lang=js"
export * from "./stapes.vue?vue&type=script&lang=js"
import style0 from "./stapes.vue?vue&type=style&index=0&id=4ec7f3b4&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7f3b4",
  null
  
)

export default component.exports